var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeviceMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.33 2.25H15.33C13.9376 2.25 12.6022 2.80312 11.6176 3.78769C10.6331 4.77226 10.08 6.10761 10.08 7.5V40.5C10.08 41.8924 10.6331 43.2277 11.6176 44.2123C12.6022 45.1969 13.9376 45.75 15.33 45.75H33.33C34.7223 45.75 36.0577 45.1969 37.0423 44.2123C38.0268 43.2277 38.58 41.8924 38.58 40.5V7.5C38.58 6.10761 38.0268 4.77226 37.0423 3.78769C36.0577 2.80312 34.7223 2.25 33.33 2.25ZM14.58 14.25H34.08V33.75H14.58V14.25ZM15.33 6.75H33.33C33.5289 6.75 33.7196 6.82902 33.8603 6.96967C34.0009 7.11032 34.08 7.30109 34.08 7.5V9.75H14.58V7.5C14.58 7.30109 14.659 7.11032 14.7996 6.96967C14.9403 6.82902 15.131 6.75 15.33 6.75ZM33.33 41.25H15.33C15.131 41.25 14.9403 41.171 14.7996 41.0303C14.659 40.8897 14.58 40.6989 14.58 40.5V38.25H34.08V40.5C34.08 40.6989 34.0009 40.8897 33.8603 41.0303C33.7196 41.171 33.5289 41.25 33.33 41.25Z",
    fill: "url(#paint0_linear_1559_2668)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1559_2668",
    x1: 24.33,
    y1: 2.25,
    x2: 24.33,
    y2: 45.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceMobile);
export default __webpack_public_path__ + "static/media/DeviceMobile.830546584456013f063d465f3c3ff036.svg";
export { ForwardRef as ReactComponent };